import React from 'react';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import NewSizeGuide from '../../../components/organisms/newSizeGuide';
import { NewSizeGuideProvider } from '../../../components/organisms/newSizeGuide/context/NewSizeGuideContext';
import { compose } from 'redux';
import withZendesk from '../../../components/HOCs/withZendesk';

const NewSizeGuideTastic = (props) => {
  const {data, openChat, context, node} = props;

  if (!data) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  return (
    <NewSizeGuideProvider
      isProductPage={node.nodeType === 'product'}
      data={data}
    >
      <NewSizeGuide
        data={data}
        openChat={() => openChat()}
      />
    </NewSizeGuideProvider>
  );
};

export default compose(
  withZendesk,
  tastify({
    translate: true,
    connect: { context: true, node: true },
  }),
)(NewSizeGuideTastic);
